import { RouteObject } from "react-router-dom";
import { DossiersList } from "../pages/admin/dossiers/DossiersList";
import { DossierDetail } from "../pages/admin/dossiers/DossierDetail";
import { ConceptsList } from "@/pages/admin/dossiers/concepts/ConceptsList";
import { AccidentReportImport } from "@/pages/admin/dossiers/accident-reports/AccidentReportImport";

export const dossiersRoutes: RouteObject[] = [
  {
    id: "dossiers-list",
    index: true,
    element: <DossiersList />,
  },
  {
    id: "concepts-list",
    path: "concepts",
    element: <ConceptsList />,
  },
  {
    id: "accident-report-import",
    path: "accident-reports",
    element: <AccidentReportImport />,
  },
  {
    id: "dossier-detail",
    path: ":id",
    element: <DossierDetail />,
  },
];
